export default "__VITE_ASSET__vPaGvbO9__"